import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { getIssueHistory } from '../../../../../packages/common/api';
import AddPlusIcon from '../../../../../packages/common/shared-ui/src/icons/addPlusIcon';
import { useTranslation } from '../../../../../packages/common/utils/getLocalString';
import { generateRedirectUrl } from '../../../../../packages/common/utils/getRedirectUrl';

// Original class: addButton
const StyledAddButton = styled(IconButton)(theme => ({
  '& .MuiSvgIcon-root': {
    '& path': {
      transition: '.2s ease',
    },
  },

  '&:hover': {
    '& .MuiSvgIcon-root': {
      '& path': {
        fill: '#7070B8',
      },
    },
  },
}));
// Original class: issueLink
const StyledIssueLink = styled(Link)(theme => ({
  '&:hover': {
    textDecoration: 'underline',
  },
}));
const IssueHistory = () => {
  const getLocalString = useTranslation();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [showHistory, setShowHistory] = useState(false);

  useEffect(() => {
    let ignore = false;
    async function getHistory() {
      const { data: history } = await getIssueHistory(params.id);
      if (!ignore) {
        return history;
      }
    }
    getHistory()
      .then(res => {
        setHistory(res);
        setLoading(false);
      })
      .catch(error => console.error(error, 'ERROR IN GET'));
    return () => {
      ignore = true;
    };
  }, [params.id]);

  const handleHistoryLink = useCallback((rowId, valueId) => {
    let url;
    rowId.includes('project_id') && (url = `/projects/${valueId}`);
    rowId.includes('relates') && (url = `/issues/${valueId}`);
    return url;
  }, []);

  const itemIsLink = useCallback((rowId, fieldId) => {
    const rows = ['relates', 'total', 'project_id', 'assigned_to_id'];
    const fields = ['history.valueFrom', 'history.valueTo'];
    return (
      rows.some(item => rowId.includes(item)) &&
      fields.some(item => fieldId.includes(item))
    );
  }, []);

  return (
    <>
      {loading ? (
        <Grid
          container
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '70px',
          }}
        >
          <CircularProgress color='secondary' />
        </Grid>
      ) : (
        <>
          <Grid
            container
            sx={{
              alignItems: 'center',
            }}
          >
            <Grid>
              <Typography
                variant='h3'
                sx={{
                  color: '#082253',
                  fontWeight: 600,
                }}
              >
                {getLocalString('IssuePage', 'sections', 'history', 'title')}
              </Typography>
            </Grid>
            <Grid>
              <StyledAddButton
                onClick={() => setShowHistory(!showHistory)}
                sx={{ padding: '6px 4px' }}
              >
                <AddPlusIcon
                  sx={{ transform: showHistory && 'rotate(180deg)' }}
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                />
              </StyledAddButton>
            </Grid>
          </Grid>
          {history.length > 0 && (
            <>
              {showHistory && (
                <Grid container direction={'column'} sx={{ marginTop: '10px' }}>
                  {history.map((historyItem, index) => {
                    const boolRemoved = historyItem.columns.filter(
                      item => item.fieldType !== 'bool',
                    );
                    return (
                      <Grid
                        key={'common-row-' + index}
                        sx={{
                          marginTop:
                            index > 0 && historyItem.rowType === 'total'
                              ? '16px'
                              : 0,
                          marginLeft:
                            historyItem.rowType !== 'total' ? '16px' : 0,
                          wordBreak: 'break-word',
                        }}
                      >
                        {historyItem.rowType === 'total' &&
                          `${getLocalString('labels', 'updated')} `}
                        {boolRemoved.map((item, index) => {
                          const stringValue = item.value ? item.value : '';
                          if (
                            itemIsLink(
                              historyItem.rowType === 'total'
                                ? historyItem.rowType
                                : historyItem.rowId,
                              item.fieldId,
                            )
                          ) {
                            return (
                              <StyledIssueLink
                                key={'common-item-' + index}
                                target={'_blank'}
                                to={handleHistoryLink(
                                  historyItem.rowType === 'total'
                                    ? historyItem.rowType
                                    : historyItem.rowId,
                                  item.valueId,
                                )}
                                style={{
                                  fontWeight:
                                    item.fieldId === '2' ||
                                    item.fieldId === 'history.valueTo' ||
                                    item.fieldId === 'history.valueFrom'
                                      ? '600'
                                      : '400',
                                }}
                              >
                                {item.value}
                              </StyledIssueLink>
                            );
                          }
                          return (
                            <Box
                              key={'common-item-' + index}
                              component={'span'}
                              sx={{
                                color: '#41424E',
                                fontWeight:
                                  item.fieldId === '2' ||
                                  item.fieldId === 'history.valueTo' ||
                                  item.fieldId === 'history.valueFrom'
                                    ? '600'
                                    : '400',
                                margin: '0 3px',
                              }}
                            >
                              {stringValue}
                            </Box>
                          );
                        })}
                      </Grid>
                    );
                  })}
                </Grid>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default IssueHistory;
